<template>
  <transition name="el-fade-in-linear">
    <div
      ref="myDiv"
      :class="[className, 'wind-farm-modal-wrapper']"
      :style="{
        width
      }"
      v-adrag
    >
      <div class="title">
        <div v-if="leftArrow" class="icon-wrapper" @click="handleLeftClick">
          <i class="el-icon-arrow-left"></i>
        </div>
        <span>
          {{ title }}
        </span>
        <div class="close-btn" @click="handleClose">
          <i class="el-dialog__close el-icon el-icon-close"></i>
        </div>
      </div>
      <div
        class="content"
        :style="{
          height: height
        }"
      >
        <slot></slot>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'mymodal',
  props: {
    title: {
      type: String,
      default: ''
    },
    invisbility: {
      type: Boolean,
      default: false
    },
    height: {
      type: String,
      default: '400px'
    },
    width: {
      type: String,
      default: '370px'
    },
    className: {
      type: String,
      default: ''
    },
    leftArrow: {
      type: Boolean,
      default: false
    }
  },
  directives: {
    adrag: {
      bind(el) {
        const dragDom = el.querySelector('.title');

        dragDom.onmousedown = e => {
          const startX = e.clientX;
          const startY = e.clientY;

          const originX = el.offsetLeft;
          const originY = el.offsetTop;

          document.onmousemove = function(e) {
            // 通过事件委托，计算移动的距离
            const l = e.clientX - startX;
            const t = (e.clientY < 85 ? 85 : e.clientY) - startY;

            // 移动当前元素
            el.style.left = `${l + originX}px`;
            el.style.top = `${t + originY}px`;
          };

          document.onmouseup = function() {
            document.onmousemove = null;
            document.onmouseup = null;
          };
        };
      }
    }
  },
  methods: {
    handleLeftClick() {
      this.$emit('leftClick');
    },
    handleClose() {
      this.$emit('closeClick');
    }
  }
};
</script>

<style lang="less">
.wind-farm-modal-wrapper {
  // &.not-login {
  //   left: 0.3%;
  // }
  position: absolute;
  width: 370px;
  z-index: 1100;
  //left: 424px;
  right: 45px;
  top: 55px;
  // border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  transform: translate(0, 0);
  .title {
    cursor: move;
    height: 43px;
    background: rgba(238, 238, 238, 0.9);
    line-height: 43px;
    color: @black-color;
    font-size: 16px;
    font-weight: bold;
    padding-left: 20px;
  }
  .close-btn {
    // border-radius: 50%;
    // border: 2px solid #0057aa;
    cursor: pointer;
    position: absolute;
    right: 10px;
    top: 0;
    .el-dialog__close {
      color: @black-color;
    }
  }
  .content {
    padding: 5px 10px;
    background: rgba(255, 255, 255, 0.9);

  }
  & > div {
    &::-webkit-scrollbar {
      width: 5px; /*滚动条宽度*/
      height: 0px; /*滚动条高度*/
      background-color: #ffffff;
    }
    //滚动条的滑块
    &::-webkit-scrollbar-thumb {
      background-color: #b4d3ee;
      border-radius: 3px;
    }
  }
  .el-table {
    background: rgba(255, 255, 255, 0);
  }
  .el-table thead{
    font-weight: bold;
    font-size: 14px;
    color:#606266;
  }
  .el-table tr {
    background: rgba(255, 255, 255, 0.6);
  }
  .el-table th.el-table__cell{
    background: rgba(226, 226, 226, 0.9);
  }
  .el-input__inner {
    background: rgba(255, 255, 255, 0.6);
  }
  .stand-select-core .el-select .el-input input {
    height: 28px;
    line-height: 28px;
  }
}
</style>
